// extracted by mini-css-extract-plugin
export default {"filtersContainer":"ManageTagsFilter_filtersContainer__xYQGR","passedContainer":"ManageTagsFilter_passedContainer__38oOb","toggleInput":"ManageTagsFilter_toggleInput__NirSr"};